import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_written_policies_procedures_place_but_informal_procedures'

export const dataPointDefinition = {
  retracedId: 'no_written_policies_procedures_place_but_informal_procedures',
  name: 'No written policies or procedures in place (but informal procedures exist)',
  description:
    'The intent of this option selection is to understand if the facility has INFORMAL (non-written) policies or procedures in place.',
  meta: {
    slcpMeta: {
      key: 'ms-1-3x',
      number: 'MS-PLA-1-2',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ms-1-3x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 32360,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
